<template>
  <div id="home">
    <Header />
    <v-main id="main" class="farmer_grey">
      <router-view></router-view>
      <updateAppDialog />
      <snack-bar
        :text="snackbar.text"
        :timeout="snackbar.timeout"
        :show="snackbar.show"
        :isTarget="snackbar.target === 'home'"
      />
    </v-main>
    <Footer />
  </div>
</template>

<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  name: 'Home',
  components: {
    Header: () => import('@/components/Header'),
    Footer: () => import('@/components/Footer'),
    updateAppDialog: () => import('@/components/shared/UpdateAppDialog')
  },
  data() {
    return {
      itemsPerPageArray: [4, 8, 12],
      search: '',
      filter: {},
      sortDesc: false,
      page: 1,
      // itemsPerPage: 4,
      sortBy: 'price',
      keys: [
        'price',
        'category',
        'district',
        'province'
      ],
      pageNumber: 1,
      products: []
    }
  },
  computed: {
    ...mapGetters(['allProducts', 'itemsPerPage', 'productsCounter', 'currentProducts', 'snackbar']),
    nbPages() {
      return Math.ceil(this.productsCounter / this.itemsPerPage)
    },
    filteredKeys() {
      return this.keys.filter(key => key !== 'Name')
    }
  },
  watch: {
    pageNumber(newVal, oldVal) {
      this.paginate(newVal)
    }
  },
  filters: {
    limitChars(string, limit) {
      if (!string) return ''
      string = string.toString()
      return string.substring(0, limit)
    }
  },
  methods: {
    paginate(pageNumber) {
      /**
       * no need to make a firebase request if elements are already in the store
       */
      window.scrollTo(0, 0)
      if ((pageNumber - 1) * this.itemsPerPage < this.allProducts.length) {
        store.dispatch('getCurrentStoreProducts', pageNumber)
      } else {
        store.dispatch('getNextProducts')
      }
    },
    goToProduct(item) {
      this.$router.push({
        name: 'Product',
        params: { id: item.id, product: item }
      })
    }
  }
}
</script>

<style lang="css" scoped>
#home {
  min-height: 100%;
  display: contents;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .8;
  position: absolute;
  width: 100%;
}
</style>
